const permissionsReference = [
    {
        "title": "Cobranças Online",
        "permissions": [
            {
                "name": "Listar cobranças online",
                "codename": "list_online_sells"
            },
            {
                "name": "Criar cobranças online",
                "codename": "add_online_sells",
                "depends_on": [
                    "list_online_sells"
                ]
            }
        ]
    },
        {
        "title": "Assinaturas Online",
        "permissions": [
            {
                "name": "Listar Planos de Assinaturas",
                "codename": "list_subscription_plan"
            },
            {
                "name": "Criar Planos de Assinaturas",
                "codename": "add_subscription_plan",
                "depends_on": [
                    "list_subscription_plan"
                ]
            }
        ]
    },
        {
        "title": "Minhas Vendas",
        "permissions": [
            {
                "name": "Listar Vendas",
                "codename": "list_transactions"
            },
            {
                "name": "Criar Split na Transação",
                "codename": "split_transaction",
                "depends_on": [
                    "list_transactions"
                ]
            },
            {
                "name": "Cancelar Transação",
                "codename": "void_transaction",
                "depends_on": [
                    "list_transactions"
                ]
            },
            {
                "name": "Listar Depósitos",
                "codename": "list_deposits"
            },
            {
                "name": "Listar Recebíveis",
                "codename": "list_receivables"
            },
            {
                "name": "Simulador de Taxas",
                "codename": "simulate_taxes"
            },
        ]
    },
    {
        "title": "Pontos de Venda",
        "permissions": [
            {
                "name": "Listar Pontos de Venda",
                "codename": "list_pos"
            },
            {
                "name": "Cadastrar Ponto de Venda",
                "codename": "add_pos",
                "depends_on": [
                    "list_pos"
                ]
            },
        ]
    },
    {
        "title": "Operação",
        "permissions": [
            {
                "name": "Listar Contas",
                "codename": "list_accounts"
            },
            {
                "name": "Credenciamento",
                "codename": "register_account",
                "depends_on": [
                    "list_accounts"
                ],
                "children": [
                    {
                        "name": "Escolher Agente",
                        "codename": "register_account_choose_agent",
                        "depends_on": [
                            "list_accounts",
                            "register_account"
                        ]
                    },
                    {
                        "name": "Escolher N1",
                        "codename": "register_account_choose_n1",
                        "depends_on": [
                            "list_accounts",
                            "register_account"
                        ]
                    },
                    {
                        "name": "Escolher N2",
                        "codename": "register_account_choose_n2",
                        "depends_on": [
                            "list_accounts",
                            "register_account"
                        ]
                    },
                    {
                        "name": "Escolher Plano",
                        "codename": "register_account_choose_plan",
                        "depends_on": [
                            "list_accounts",
                            "register_account"
                        ]
                    },
                    {
                        "name": "Escolher Conta Pai",
                        "codename": "register_account_sub",
                        "depends_on": [
                            "list_accounts",
                            "register_account"
                        ]
                    },
                ]
            },
            {
                "name": "Editar Conta",
                "codename": "edit_account",
                "depends_on": [
                    "list_accounts"
                ]
            },
            {
                "name": "Editar Plano Split da Conta",
                "codename": "edit_account_taxes",
                "depends_on": [
                    "list_accounts",
                    "edit_account"
                ]
            },
        ]
    },
    {
        "title": "Risco & Compliance",
        "permissions": [
            {
                "name": "Listar Vendas em Disputa",
                "codename": "list_transactions_dispute"
            },
        ]
    },
    {
        "title": "Configurações",
        "permissions": [
            {
                "name": "Gerenciar Perfis",
                "codename": "manage_groups"
            },
            {
                "name": "Gerenciar Usuários",
                "codename": "manage_users"
            },
            {
                "name": "Gerenciar Acessos",
                "codename": "manage_accesses",
                "depends_on": [
                    "manage_users",
                    "manage_groups"
                ]
            },
        ]
    },
];

export default permissionsReference;